{
  "add-a-stream": {
    "button": "Añadir un stream"
  },
  "add-new-page": {
    "audio-dedications": "Dedicatoria de audio",
    "dedications": "Dedicatoria",
    "html": "HTML",
    "livefeed": "LiveFeed",
    "podcast": "Podcast",
    "reveil": "Despertador",
    "rss": "RSS",
    "rss-news": "Noticias",
    "rss-podcasts": "Podcast",
    "rss-video": "Vídeo",
    "site": "Sitio web",
    "song-history": "Historial de canciones",
    "title": "Añadir una página"
  },
  "android-screenshot": {
    "desc": "<p class='mb-[10px]'>La imagen mostrada corresponde a la vista previa generada durante la publicación. Este estado indica que tu aplicación se publicó por primera vez.</p><p>No se actualiza automáticamente: las actualizaciones, verificaciones o alertas deben seguirse desde tu cuenta de desarrollador de Google.</p>",
    "title": "Tu aplicación está disponible en Google Play Store."
  },
  "app-update-available": {
    "cta": "Actualizar",
    "description": "Disfruta de las últimas funciones de la aplicación",
    "title": "Actualización disponible"
  },
  "app-update-modal": {
    "desc": "Para actualizar tu aplicación, deberás generar la nueva versión y seguir el tutorial de actualización.",
    "title": "Actualización de tu aplicación"
  },
  "assets": {
    "app-logo": "Logo de la aplicación",
    "app-logo-explained": "Esta imagen corresponde al logo de tu aplicación.",
    "app-logo-size": "Tamaño recomendado: 2500px x 2500px",
    "app-name": "Nombre de tu aplicación de radio",
    "apple-only": "Solo en Apple",
    "change-image": "Reemplazar imagen",
    "constraints-icon-smartphone": "Tamaño recomendado: 1024 x 1024px",
    "constraints-icon-tv": "Tamaño recomendado: 1280 x 768px",
    "constraints-smartphone": "Tamaño recomendado: 1242 x 2208px",
    "constraints-smartphone-long": "Tamaño recomendado: 1242 x 2688px",
    "constraints-topshelf-tv": "Tamaño recomendado: 4640 x 1440px",
    "constraints-tv": "Tamaño recomendado: 3840 x 2160px",
    "crop-image": "Recortar imagen",
    "icon-tv": "Icono para la aplicación de TV",
    "icon-tv-description": "Este icono se muestra en la página de inicio de las aplicaciones de TV.",
    "images-title": "Pantallas y logotipos",
    "large-screen": "Pantalla grande",
    "logo": "Icono de la aplicación",
    "logo-description": "Esta imagen representa el icono en el que el usuario hace clic para iniciar la aplicación.",
    "next-step": "Paso siguiente",
    "restrictions": "Restricciones técnicas",
    "restrictions-icon-tv": "Debe incluir el nombre completo de la aplicación, sin texto cortado ni mención de la frecuencia FM, salvo que esté presente en el nombre.",
    "restrictions-splashscreen-tv": "Ni la imagen ni el texto deben estar cortados.",
    "smartphone": "Smartphone",
    "smartphone-description": "Esta imagen corresponde a la pantalla de inicio de la aplicación.",
    "smartphone-long-description": "Esta imagen corresponde a la pantalla de inicio de la aplicación en teléfonos con pantalla más grande.",
    "splashscreens": "Pantallas de inicio",
    "splashscreens-explained": "Esta imagen corresponde a la pantalla mostrada al iniciar la aplicación en distintos dispositivos (teléfono, televisión)",
    "splashscreens-size": "Tamaño recomendado: 2500px x 2500px",
    "topshelf-tv-description": "Imagen mostrada como vista previa de la aplicación en la interfaz de Apple TV",
    "topshelf-tv-short": "Banner de TV",
    "tv": "Pantalla de TV",
    "tv-description": "Esta imagen se muestra al iniciar la aplicación en la televisión.",
    "update-image-title": "Pantallas y logotipos"
  },
  "audio-dedications": {
    "choose-radio": "Elige una radio",
    "end": "Fin",
    "end-placeholder": "¡Gracias por tu dedicatoria!",
    "need-a-rk-radio": "Esta página requiere un stream de RadioKing para funcionar.",
    "radio": "Radio",
    "rk-create-radio-cta": "Crear mi radio",
    "rk-radio-create-link": "/create-trial-radio",
    "text": "Texto",
    "welcome": "Bienvenido",
    "welcome-placeholder": "¡Envía tu dedicatoria al aire!"
  },
  "changelog": {
    "fixes": "Correcciones",
    "improvement": "Mejoras",
    "new": "Novedad",
    "read-more": "Leer más",
    "title": "Novedades"
  },
  "color-selector": {
    "hex-error": "El código de color no es correcto.",
    "opacity": "Opacidad",
    "opacity-error": "La opacidad debe estar entre 0 y 100"
  },
  "config-submenu": {
    "content": "Contenido",
    "design": "Diseño"
  },
  "create-app-form": {
    "change-image": "Cambiar imagen",
    "choose-name": "Elige el nombre de la aplicación",
    "choose-name-explained": "Elige un nombre único para tu aplicación móvil. Podrás cambiarlo más adelante si es necesario.",
    "max-length": "La longitud máxima es de 30 caracteres.",
    "min-length": "La longitud mínima es de 2 caracteres.",
    "missing-name": "El nombre es obligatorio.",
    "name-placeholder": "Nombre de tu aplicación",
    "no-emojis": "No se permiten emojis.",
    "no-spaces-only": "El nombre no puede contener solo espacios.",
    "start": "Empezar",
    "unavailable-name": "Este nombre de aplicación ya está en uso"
  },
  "dashboard": {
    "consumption": "Consumo de notificaciones",
    "hello": "Hola",
    "new-subscribers": "Nuevos suscriptores en los últimos 7 días",
    "new-subscribers-unit": "{count, plural, =1 {Nuevo suscriptor} other {Nuevos suscriptores}}",
    "notifications-sent": "Notificaciones enviadas",
    "notifications-sent-unit": "{count, plural, =1 {Notificación} other {Notificaciones}}",
    "subscriber-detail": "Distribución de usuarios",
    "subscribers-total": "Suscriptores a notificaciones",
    "title": "Estadísticas de notificaciones",
    "welcome": "Bienvenido a tu panel de control."
  },
  "general-configuration": {
    "app-langugage": "Idioma de la aplicación",
    "background-color": "Color 1",
    "background-color-2": "Color 2",
    "background-color-style": "Estilo",
    "background-gradient-direction": "Dirección",
    "bicolor-color-tooltip": "Bicolor",
    "blur": "Desenfoque",
    "blur-details": "El desenfoque de fondo permite añadir un efecto visual a tu imagen para destacar el contenido principal.",
    "body-size": "Tamaño del cuerpo",
    "button-color": "Color del botón",
    "button-label": "Botón",
    "button-type": "Tipo de botón",
    "color": "Color",
    "cover": "Carátula",
    "cover-background-details": "La carátula del tema actual se mostrará como imagen de fondo.",
    "default-background-image": "Imagen por defecto",
    "font-size": "Tamaño del texto",
    "gradient-color-tooltip": "Degradado",
    "header": "Cabecera",
    "header-text-color": "Color del texto",
    "icons": "Iconos",
    "image": "Imagen",
    "invert-colors": "Invertir colores",
    "long-background-image": "Imagen larga",
    "rounded-borders": "Bordes redondeados",
    "shodow-box": "Sombras",
    "show-logo": "Mostrar logo",
    "solid-color-tooltip": "Sólido",
    "styles": "Estilos",
    "styles-background": "Fondo",
    "text-align": "Alineación del texto",
    "typography": "Tipografía"
  },
  "global": {
    "cancel": "Cancelar",
    "share": "Compartir",
    "url-copied": "La URL se ha copiado correctamente al portapapeles.",
    "url-copy-failed": "No se ha podido copiar la URL al portapapeles. Inténtalo de nuevo.",
    "url-invalid": "La URL es incorrecta",
    "validate": "Validar"
  },
  "header": {
    "help-link": "https://help.radioking.com/hc/en-us/categories/4408651163665-Mobile-application",
    "language": "Idioma"
  },
  "html-config": {
    "background": "Fondo del bloque HTML",
    "code-placeholder": "Introduce aquí tu código HTML",
    "content": "Contenido de la página"
  },
  "icon-search": {
    "icon-name": "Nombre del icono"
  },
  "icon-type-selector": {
    "regular": "Contorno",
    "solid": "Relleno"
  },
  "image-cropper": {
    "cancel": "Cancelar",
    "iconTv": "Cambiar el icono de la aplicación de TV",
    "logo": "Cambiar la imagen del logo de la aplicación",
    "recommended": "Tamaño recomendado",
    "replace": "Reemplazar la imagen",
    "restrictions": "Restricciones técnicas",
    "rotation": "Rotación",
    "save": "Guardar",
    "splashscreen": "Cambiar la imagen de la pantalla de inicio",
    "splashscreenLarge": "Cambiar la imagen de la pantalla de inicio grande",
    "splashscreenTv": "Cambiar la imagen de la pantalla de TV",
    "topShelfTv": "Cambiar la imagen del banner de TV",
    "zoom": "Zoom"
  },
  "image-input": {
    "cancel": "Cancelar",
    "dragging-over-text": "Suelta tu imagen para cargarla",
    "load": "cargar",
    "main-text": "Arrastra y suelta \no"
  },
  "image-size-guide": {
    "size": "Tamaño recomendado: \n{width} x {height}px\nTamaño máximo: 10Mo"
  },
  "image-upload": {
    "alt": "Imagen cargada",
    "change-image": "Cambiar imagen",
    "constraints-title": "Especificaciones técnicas",
    "delete": "Eliminar",
    "file-size-error": "El tamaño máximo del archivo es de 10Mo",
    "file-type-error": "Formatos aceptados: .jpg, .jpeg, .png,"
  },
  "ios-publishing-empty-state": {
    "cta": "Actualizar a Premium",
    "desc": "Tus oyentes también usan iPhone. Añade la opción iOS y ofréceles una experiencia completa, directamente desde la App Store.",
    "title": "Tu aplicación en iOS"
  },
  "ios-screenshot": {
    "desc": "<p class='mb-[10px]'>La imagen mostrada corresponde a la vista previa generada durante la publicación. Este estado indica que tu aplicación se publicó por primera vez.</p><p>No se actualiza automáticamente: las actualizaciones, verificaciones o alertas deben seguirse desde tu cuenta de desarrollador de Apple.</p>",
    "title": "Tu aplicación ya está disponible en la App Store."
  },
  "login": {
    "login-button": "Iniciar sesión"
  },
  "margin-settings": {
    "no-margin": "Sin margen",
    "with-margin": "Con margen"
  },
  "menu-content": {
    "title-error": "El nombre de la página debe contener al menos dos caracteres"
  },
  "menu-design": {
    "background": "Fondo",
    "show-logo": "Mostrar logo",
    "styles": "Estilos",
    "text-color": "Color del texto"
  },
  "menu": {
    "configuration": "Configuración",
    "content": "Diseño y contenido",
    "dashboard": "Panel",
    "notifications": "Notificaciones",
    "pages": "Páginas",
    "publication": "Publicación",
    "publishing": "Publicación",
    "settings": "Ajustes"
  },
  "mobile-access-warning": {
    "cta": "Acceder a la versión de escritorio",
    "description": "El simulador de tu aplicación aún no está disponible en móvil. Mientras tanto, puedes disfrutar de todas sus funciones en tu ordenador.",
    "description-app-manager": "El gestor de tu aplicación aún no está disponible en móvil. Mientras tanto, puedes disfrutar de todas sus funciones en tu ordenador.",
    "title": "Disponible próximamente"
  },
  "mock-tabs": {
    "alarm": "Despertador",
    "dedications": "Dedicatorias",
    "podcast": "Podcast",
    "podcast-link": "https://feed.ausha.co/o9W6DIj52NE0",
    "rss": "Feed RSS",
    "rss-link": "https://es.radioking.com/blog/feed",
    "rss-news": "Noticias",
    "rss-podcasts": "Podcast",
    "rss-video": "Vídeo",
    "shout-outs": "Saludos",
    "song-history": "Historial de canciones",
    "video-link": "https://www.youtube.com/feeds/videos.xml?channel_id=UCuA6ECflXH9hpx5iDBa79uw",
    "website": "Sitio web"
  },
  "monetization": {
    "ad-unit-id": "ID de unidad de anuncio",
    "admob-configuration-tutorial": "¿Cómo configurar AdMob?",
    "admob-configuration-tutorial-url": "https://help.radioking.com/hc/en-us/articles/4410223563025",
    "admob-get-id-tutorial": "¿Cómo obtener tus ID de AdMob?",
    "admob-get-id-tutorial-url": "https://help.radioking.com/hc/en-us/articles/4410238783377",
    "and": "y",
    "android-app-id": "ID de aplicación Android",
    "banner": "Banner",
    "banner-description": "Publicidad mostrada en la página del reproductor de la aplicación.",
    "change-offer-text": "Pásate a la monetización. Una forma sencilla de empezar a generar ingresos con tu aplicación.",
    "configure-later": "Puedes configurar la monetización ahora o activarla más tarde.",
    "description-1": "Google AdMob te permite monetizar tu aplicación mostrando publicidad.",
    "description-2": "Para configurar AdMob, visita el sitio web de AdMob",
    "interstitial": "Intersticial",
    "interstitial-description": "Publicidad mostrada al abrir la aplicación.",
    "ios-app-id": "ID de aplicación iOS",
    "next-step": "Paso siguiente",
    "option-toggle": "Activar anuncios",
    "our-tutorials": "en nuestros tutoriales",
    "title": "Monetización"
  },
  "new-stream": {
    "name": "Mi radio"
  },
  "notification-congrats-dialog": {
    "button": "Empezar",
    "desc": "¡Toma el control total de tu aplicación móvil con facilidad! Personalízala, envía notificaciones y monitoriza tu rendimiento directamente desde tu panel.",
    "title": "¡Enhorabuena por configurar tu aplicación!"
  },
  "notification-dashboard": {
    "empty-state": {
      "desc": "Tu aplicación acaba de publicarse. Tus primeros resultados aparecerán en este panel en breve.",
      "title": "Aún no tienes estadísticas",
      "tutorial": {
        "card1": {
          "desc": "Aprende a enviar, segmentar y analizar tus notificaciones push para captar a tu audiencia de manera eficaz.",
          "title": "Todo lo que necesitas saber sobre las notificaciones push",
          "url": "https://help.radioking.com/hc/en-us/articles/4410238827409"
        },
        "card2": {
          "desc": "Descubre lo fácil que es configurar, actualizar y publicar tu aplicación móvil.",
          "title": "Todo sobre la aplicación móvil",
          "url": "https://help.radioking.com/hc/en-us/categories/4408651163665"
        },
        "learn-more": "Más información",
        "title": "Déjanos guiarte"
      }
    },
    "send": "Enviar una notificación",
    "title": "Notificaciones",
    "total": "{count, plural, =0 {Envía tu primera notificación} =1 {Has enviado una notificación} other {Has enviado # notificaciones}}"
  },
  "notification-form": {
    "cancel": "Cancelar",
    "close-confirmation-button": "Sí, salir.",
    "close-confirmation-message": "¿Seguro que quieres salir de la creación de tu notificación?",
    "close-confirmation-message-details": "Cerrar la ventana actual hará que se pierdan los cambios en curso. ¿Seguro que quieres salir sin guardar?",
    "close-confirmation-tooltip": "Se ha producido un error en la redacción de tu notificación. Para guardarla, revisa el formulario.",
    "date-placeholder": "Elige una fecha",
    "deeplink": "Enlace profundo",
    "deeplink-desc": "Cuando se haga clic en la notificación, el oyente será redirigido a la página seleccionada.",
    "deeplink-placeholder": "Selecciona una página",
    "draft": "Guardar como borrador",
    "episode-placeholder": "Selecciona un episodio",
    "episode-selection": "Episodio (opcional)",
    "language": "Idioma",
    "language-placeholder": "Elige tu idioma o idiomas",
    "location": "Ubicación",
    "location-placeholder": "País, ciudad, región, ...",
    "location-search": "Enviar una notificación geolocalizada",
    "message": "Mensaje",
    "message-error": "El mensaje debe contener entre 3 y 140 caracteres.",
    "message-placeholder": "Escribe tu mensaje",
    "new": "Nueva notificación",
    "os": "Sistema operativo",
    "platform-error": "Elige al menos un sistema operativo",
    "podcast-placeholder": "Selecciona un podcast",
    "podcast-selection": "Título del podcast (opcional)",
    "schedule": "Programar",
    "send": "Enviar",
    "time-placeholder": "Hora",
    "title": "Título",
    "title-error": "El título (opcional) debe contener entre 3 y 50 caracteres.",
    "title-placeholder": "Título de tu notificación",
    "tooltip-support-ios": "Para enviar tus notificaciones en iOS, pásate a una suscripción superior.",
    "tooltip-unavailable-android": "Las notificaciones aún no están disponibles para tu aplicación Android.",
    "tooltip-unavailable-ios": "Las notificaciones aún no están disponibles para tu aplicación iOS."
  },
  "notification-sidebar": {
    "empty-state": {
      "desc": "Tras el primer envío, podrás consultar el historial de tus notificaciones.",
      "title": "Envía tu primera notificación"
    },
    "scheduled": "Programada"
  },
  "notification-table": {
    "android": "Enviada en Android",
    "date": "Fecha de envío",
    "draft": "Borrador",
    "empty-state-desc": "Informa a tus oyentes de las novedades de tu radio, lo que está ocurriendo y mucho más.",
    "ios": "Enviada en iOS",
    "message": "Mensaje",
    "not-sent-android": "Esta notificación no se ha enviado en Android",
    "not-sent-ios": "Esta notificación no se ha enviado en iOS",
    "reach": "Suscriptores alcanzados"
  },
  "notification-targeted-subscribers": {
    "android": "en Android",
    "ios": "en iOS",
    "total": "Envíos estimados"
  },
  "onboarding-modal": {
    "content-design": {
      "button": "Seguir editando",
      "desc": "Usa las pestañas para alternar entre editar el contenido y personalizar el diseño de la página seleccionada.",
      "title": "Contenido y diseño"
    },
    "general-configuration": {
      "desc": "Personaliza el tema de tu aplicación móvil para adaptarlo a tus necesidades.",
      "title": "Configuración del tema"
    },
    "interface": {
      "button": "Finalizar",
      "desc": "Personaliza los elementos visuales de tu aplicación. Ajusta el idioma, los colores, la tipografía y los iconos para crear una experiencia de usuario única.",
      "title": "Personalización de la interfaz"
    },
    "menu": {
      "desc": "Organiza y personaliza el menú de tu aplicación móvil para ofrecer una navegación óptima a tus oyentes.",
      "title": "Gestión del menú"
    },
    "next": "Siguiente",
    "pages": {
      "desc": "Crea, modifica y organiza las páginas de tu aplicación móvil.",
      "title": "Gestión de páginas"
    },
    "previous": "Anterior",
    "stepper": {
      "button": "Pasar a la siguiente etapa",
      "desc": "Visualiza tu progreso en cada etapa de la creación del proyecto. Haz clic en «Paso siguiente» para continuar.",
      "title": "Sigue tu progreso"
    }
  },
  "other-config": {
    "need-a-rk-website": "⚠️ Esta página requiere un sitio web de RadioKing para funcionar.",
    "rk-website-create-link": "/crear-sitio-cms-radio",
    "rk-website-cta": "Crear mi sitio web de radio",
    "rk-website-link": "Enlace a tu sitio web de radio",
    "rss-link": "Enlace al feed RSS",
    "website-link": "Enlace del sitio web",
    "what-is-rss": "Un <strong>feed RSS</strong> es un enlace web que se actualiza automáticamente con tu último contenido.<br/>Si no sabes dónde encontrar tu feed RSS, consulta tu plataforma de contenido o tu servicio de alojamiento; suele aparecer como «Feed RSS» o «URL del feed»."
  },
  "page-config": {
    "background-color": "Color de fondo",
    "header-text-color": "Color del texto de la cabecera",
    "icon-and-name": "Icono y nombre de la página"
  },
  "paid-publication-modal": {
    "buy": "Añadir al carrito",
    "buy-android": "Publicar en Android",
    "buy-ios": "Publicar en iOS",
    "cancel": "Cancelar",
    "message": "Por { price } por plataforma, RadioKing se encarga de publicar tu aplicación en tus cuentas de desarrollador de Apple o Google, cumpliendo con los requisitos de las tiendas. <a target='_blank' href='https://www.radioking.com/app-publishing' class='underline text-brand'>Descubre en detalle los pasos que llevaremos a cabo.</a>",
    "title": "Publicación por RadioKing"
  },
  "plan": {
    "all-basic": "Todas las funciones de la oferta Basic",
    "all-smart": "Todas las funciones de la oferta Smart",
    "android": "Aplicación nativa para <b>Android</b>",
    "android-and-ios": " Aplicación nativa para <b>Android & iPhone</b>",
    "android-tablet": "Compatible con <b>tablets Android</b>",
    "annual": "Anual",
    "apple-watch": "<b>Apple Watch</b>",
    "auto": "<b>Android Auto & Apple CarPlay</b>",
    "carplay-tooltip": "Sujeto a la aceptación de Apple (1-3 semanas) para CarPlay",
    "choose": "Elegir esta oferta",
    "customizable": "Diseño 100% personalizable",
    "monetization": "Monetización",
    "monetization-tooltip": "Gestor de publicidad: AdMob",
    "monthly": "Mensual",
    "multi-language": "Multilingüe",
    "multi-language-tooltip": "Elige entre 6 idiomas distintos al crear la aplicación: FR, EN, ES, DE, IT, PT",
    "multi-stream": "Añade varios streams de radio",
    "multi-stream-tooltip": "Compatible con Shoutcast, Icecast y otros proveedores",
    "per-month": "/mes",
    "per-year": "/año",
    "pick-title": "Elegir mi oferta",
    "plus": "más",
    "publication-tooltip": "Válido solo para 1 publicación",
    "push": "<b>{number}</b> notificaciones push",
    "push-tooltip": "<b>Notificaciones adicionales:</b></br>100 000: +{currency}5/mes</br>300 000: +{currency}15/mes</br>500 000: +{currency}25/mes</br>750 000: +{currency}35/mes",
    "recommended": "Recomendado para ti",
    "rk-published": "Aplicación publicada por RadioKing <b>INCLUIDO</b>",
    "subtitle": "Elige la oferta que tú y tu equipo necesitáis.",
    "tablet": "Compatible con <b>iPad y tablets Android</b>",
    "tv": "<b>Android TV y Apple TV</b>",
    "two-months-free": "2 meses gratis",
    "unlimited-downloads": "Descargas de la aplicación <b>ILIMITADAS</b>",
    "unlimited-tabs": "Pestañas <b>ILIMITADAS</b>",
    "user-published": "Aplicación publicada por RadioKing (opcional)",
    "user-published-tooltip": "{currency}50 por publicación de aplicación",
    "white-label": "Marca blanca",
    "white-label-tooltip": "La marca blanca te permite eliminar cualquier referencia a «RadioKing» en tu aplicación."
  },
  "player-buttons": {
    "apple": "Comprar en Apple Music",
    "apple-afiliate-help-link": "https://help.radioking.com/hc/en-us/articles/4409541483665-External-APIs-How-to-Get-Your-Apple-Partner-formerly-iTunes-Affiliate-Code",
    "apple-music-placeholder": "Tu ID de afiliado de Apple Music",
    "auto-play": "Reproducción automática",
    "email": "Correo electrónico",
    "email-error": "La dirección de correo electrónico no es correcta",
    "infobox-itunes": "💡 El botón «Comprar en Apple Music» permite a tus oyentes adquirir la pista actual. Es una excelente forma de monetizar tu aplicación.<br/><br/>Para aprovecharlo, debes inscribirte en el Programa de Afiliados de Apple.",
    "infobox-itunes-cta": "Más información",
    "mail-placeholder": "contacto@mi-radio.com",
    "other-actions": "Otras acciones",
    "phone": "Llamar",
    "phone-error": "El número de teléfono no es correcto",
    "phone-placeholder": "+44 72 90 78 65",
    "share": "Compartir",
    "sleep-timer": "Temporizador",
    "sms": "SMS",
    "sms-placeholder": "+44 79 60 22 96",
    "title": "Botones",
    "vote": "Votar",
    "vote-explained": "Los votos permiten a tus oyentes indicarte cuándo les gusta tu música. Esta función solo está disponible para las radios alojadas por RadioKing."
  },
  "player-content": {
    "icon-and-name": "Icono y nombre de la página",
    "stream": "Stream de radio"
  },
  "player-design": {
    "always-show-default-cover": "Mostrar siempre la carátula por defecto",
    "artist-color": "Color del artista",
    "constraints-body": "Tamaño recomendado: 440 x 440px\nPeso máximo: 10MB\nFormatos aceptados: .jpg, .jpeg, .png",
    "cover": "Carátula por defecto",
    "cover-border-color": "Color del borde de la carátula",
    "cover-explained": "La carátula por defecto es la imagen que sustituye a la foto del tema actual cuando no tiene una.",
    "cover-shape": "Forma de la carátula",
    "cover-type": "Estilo de la carátula",
    "show-cover-border": "Mostrar borde de la carátula",
    "title-and-artist": "Título y artista",
    "title-color": "Color del título",
    "titling-background": "Fondo"
  },
  "privacy": {
    "description": "Configura los ajustes de tu plataforma de gestión del consentimiento (CMP) para cumplir con el RGPD.",
    "didomi-api-key": "Clave API de Didomi",
    "didomi-api-key-placeholder": "Introduce tu clave API de Didomi",
    "didomi-notice-id": "ID de aviso de Didomi",
    "didomi-notice-id-placeholder": "Introduce tu ID de aviso de Didomi",
    "option-toggle": "Activar la CMP de Didomi",
    "privacy-policy-url": "URL de la política de privacidad",
    "privacy-policy-url-placeholder": "https://ejemplo.com/privacidad",
    "terms-of-service-url": "URL de las condiciones de uso",
    "terms-of-service-url-placeholder": "https://ejemplo.com/condiciones",
    "title": "Privacidad"
  },
  "podcast-config": {
    "add": "Añadir un podcast",
    "duplicate": "Esta URL de podcast ya ha sido añadida",
    "episodes": "episodios",
    "feed-link": "Enlace del feed del podcast",
    "invalid": "La URL introducida no es un feed RSS de podcast"
  },
  "publication-addon-dialog": {
    "accept": "Que RadioKing publique por mí",
    "message": "Nos encargamos de toda la publicación de tu aplicación en tus cuentas de desarrollador de Apple y Google. Confíanos esta tarea y asegúrate de que tu aplicación esté disponible rápidamente, conforme a los requisitos de las plataformas.<br/><br/>Esta opción cuesta solo { price } por una sola vez.<br/><br/>Si prefieres publicarla por tu cuenta, nuestros tutoriales te guiarán paso a paso.",
    "refuse": "Publico yo mismo",
    "title": "¿Quieres que RadioKing publique la aplicación por ti?"
  },
  "publishing-banner": {
    "cta": "Publicar",
    "description": "Por 50 € por plataforma, RadioKing se encarga de publicar tu aplicación en tus cuentas de desarrollador de Apple o Google, cumpliendo con los requisitos de las tiendas. ",
    "link": "https://www.radioking.com/app-publishing",
    "link-description": "Más información sobre la publicación por RadioKing.",
    "title": "RadioKing publica por mí"
  },
  "publishing-step": {
    "android-dev-account-cta": "Crear mi cuenta",
    "android-dev-account-description": "Crear y validar tu cuenta de desarrollador de Google es necesario para publicar tu aplicación. Para saber más, consulta nuestro tutorial.",
    "android-dev-account-label": "Crear mi cuenta de Play Store",
    "android-tutorial-description": "Sigue el tutorial para enviar tu aplicación a Google y publicarla en Play Store.",
    "android-tutorial-label": "Subir la aplicación a Play Store",
    "download-cta": "Descargar mi aplicación",
    "download-description": "Descarga el archivo de tu aplicación. Este archivo es necesario para la publicación en las tiendas.",
    "download-label": "Descargar la aplicación",
    "existing-dev-account": "Ya tengo una cuenta",
    "generation-cta": "Iniciar la generación",
    "generation-description": "Este paso inicia el proceso automático de creación de tu aplicación a partir de los elementos que has proporcionado (nombre, icono, contenido, etc.). Una vez completada la generación, podrás descargar los archivos necesarios para la publicación.",
    "generation-label": "Generar la aplicación",
    "in-progress": "En curso",
    "ios-carplay-cta": "Solicitar autorización para CarPlay",
    "ios-carplay-description": "Solicita la autorización de Apple para que tu aplicación sea compatible con CarPlay. Esto puede tardar varias semanas.",
    "ios-carplay-label": "Solicitar autorización para CarPlay",
    "ios-dev-account-cta": "Crear mi cuenta",
    "ios-dev-account-description": "Crear y validar tu cuenta de desarrollador de Apple es necesario para publicar tu aplicación. Para saber más, consulta nuestro tutorial.",
    "ios-dev-account-label": "Crear mi cuenta de App Store",
    "ios-tutorial-description": "Sigue el tutorial para enviar tu aplicación a Apple y publicarla en la App Store.",
    "ios-tutorial-label": "Subir tu aplicación a la App Store",
    "published-label": "¡Enhorabuena, tu aplicación ya está en línea!",
    "tutorial-cta": "Iniciar publicación"
  },
  "publishing": {
    "app-swap": "Cambiar de aplicación",
    "subtitle": "Publica tu aplicación paso a paso y haz seguimiento de su estado de publicación",
    "title": "Estado de publicación"
  },
  "setting-confirmation-modal": {
    "cancel": "Cancelar",
    "description": "Para que los cambios de configuración sean visibles para los usuarios, tu aplicación deberá publicarse de nuevo.",
    "documentation": "documentación",
    "link": "https://help.radioking.com/hc/en-us/articles/26106170721041",
    "link-description": "Encontrarás más información en nuestra ",
    "save": "Guardar sin publicar",
    "save-redirect": "Guardar y publicar",
    "title": "Publicar cambios"
  },
  "settings-list": {
    "general-configuration": "Ajustes del tema",
    "menu": "Menú",
    "pages": "Páginas"
  },
  "simulator-preview": {
    "add-image-text": "Sube una imagen para ver la vista previa",
    "add-image-title": "Añade tu imagen"
  },
  "song-history-config": {
    "api-url": "URL de la API",
    "api-url-description": "API que proporciona el historial de los temas reproducidos recientemente.",
    "search-api-url": "URL de la API de búsqueda",
    "search-api-url-description": "API que permite buscar temas en el historial."
  },
  "stepper": {
    "design": "Diseño y contenido",
    "images": "Imágenes",
    "last": "Tu turno",
    "monetization": "Monetización",
    "name": "Nombre",
    "next": "Paso siguiente",
    "plan": "Oferta",
    "previous": "Paso anterior",
    "save": "Guardar"
  },
  "stream-list": {
    "search-placeholder": "Buscar un stream",
    "empty-search-title": "No se ha encontrado ningún stream",
    "empty-search-description": "Prueba con otra palabra clave.",
    "sort-confirm-title": "¿Ordenar alfabéticamente?",
    "sort-confirm-message": "El orden actual de tus streams será reemplazado por una ordenación alfabética.",
    "sort-confirm-button": "Ordenar",
    "cancel": "Cancelar"
  },
  "stream-list-item": {
    "edit": "Editar",
    "move-to-top": "Mover al principio",
    "move-to-bottom": "Mover al final",
    "delete": "Eliminar",
    "delete-confirm-title": "¿Eliminar este stream?",
    "delete-confirm-message": "¿Seguro que quieres eliminar este stream? Esta acción no se puede deshacer.",
    "delete-confirm-button": "Eliminar",
    "cancel": "Cancelar"
  },
  "stream-edit": {
    "choose-mountpoint": "Elige un punto de montaje",
    "choose-radio": "Elige una radio",
    "logo": "Logo del stream",
    "mount-point": "Punto de montaje",
    "name": "Nombre del stream",
    "other": "MP3 / AAC",
    "radio": "Radio",
    "radioking-no-radios-error": "Debes tener un stream de RadioKing para elegir esta opción",
    "stream-type": "Tipo de stream",
    "stream-url": "URL del stream",
    "title-url": "URL del titular",
    "title-url-infobox": "💡 Introduce la URL de una página web que muestre únicamente: «Artista - Título de la canción»",
    "url-hls-not-allowed": "Solo los flujos HLS pueden usar una URL .m3u8",
    "url-required": "Se requiere una URL"
  },
  "stream-modal": {
    "title-add": "Añadir un stream",
    "title-edit": "Editar stream",
    "name-placeholder": "Nombre del stream",
    "type-placeholder": "Selecciona un tipo",
    "title-url-description": "Comparte la URL de una página que contenga únicamente: «Artista - Título de la canción»",
    "cancel": "Cancelar",
    "confirm-close": "Cerrar esta ventana provocará la pérdida de los cambios en curso. ¿Seguro que quieres salir sin guardar?",
    "add": "Añadir",
    "save": "Guardar",
    "duplicate-url": "Este stream ya está siendo utilizado por {name}"
  },
  "toast": {
    "generic-error": "Se ha producido un error. Inténtalo de nuevo más tarde",
    "generic-fetch-error": "Se ha producido un error. Inténtalo de nuevo más tarde",
    "login_error": "Contraseña o nombre de usuario incorrectos",
    "notification-deleted": "Tu notificación ha sido eliminada",
    "notification-draft": "Tu borrador ha sido guardado",
    "notification-frequency-error": "Debes espaciar el envío de tus notificaciones al menos 5 minutos.",
    "notification-quota-error": "Has superado tu cuota y enviado demasiadas notificaciones push.",
    "notification-scheduled": "Notificación programada",
    "notification-sent": "Notificación enviada",
    "notification-updated": "Notificación actualizada",
    "post-config-success": "Tus cambios se han guardado correctamente."
  },
  "tutorial-modal": {
    "close": "Ver más tarde",
    "validate": "He terminado"
  },
  "unsaved-changes-dialog": {
    "cancel": "Cancelar",
    "close-confirmation-button": "Cerrar sin guardar",
    "close-confirmation-message": "Cerrar sin guardar",
    "close-confirmation-message-details": "¿Quieres cerrar sin guardar los cambios?"
  },
  "update-content": {
    "save": "Guardar",
    "subtitle": "Modifica el diseño y el contenido de tu aplicación.",
    "title": "Diseño y contenido"
  },
  "update-settings": {
    "nav": {
      "logos": "Pantallas y logotipos",
      "monetization": "Monetización",
      "name": "Nombre",
      "privacy": "Privacidad"
    },
    "save": "Guardar y publicar",
    "subtitle": "Modifica los ajustes de tu aplicación.",
    "title": "Ajustes"
  },
  "update_toast": {
    "update-available": "Hay una actualización disponible.",
    "update-now": "Actualizar ahora"
  },
  "upgrade-offer": {
    "button": "Pasar a la oferta superior",
    "description": "Mantén informados a tus oyentes en tiempo real con notificaciones ultraprecisas y personalizadas (filtradas por país, idioma, plataforma y más). ¡Aumenta tu visibilidad!",
    "image": "/assets/smartphone-notif-example-en.png",
    "title": "Maximiza la implicación de tu audiencia con notificaciones segmentadas"
  },
  "user-menu": {
    "customer": "Área de cliente",
    "help": "Centro de ayuda",
    "logout": "Cerrar sesión",
    "news": "Novedades",
    "news-link": "https://headwayapp.co/radioking-en-changelog"
  },
  "welcome-animation": {
    "message": "¡Gracias por elegir RadioKing para tu aplicación móvil!\nTe acompañaremos desde la edición de tu aplicación hasta su publicación en las tiendas.",
    "welcome": "Bienvenido"
  }
}
